import { useEffect, useState } from "react";
import Lottie from "lottie-react";
import { Container, StickerLabel } from "components/ImageMessage/styles";
import { LottieStickerMessageProps } from "./types";

export function LottieStickerMessage({ message }: LottieStickerMessageProps) {
  const [animationData, setAnimationData] = useState<object | null>(null);

  useEffect(() => {
    let isMounted = true;

    fetch(message.body)
      .then(response => response.json())
      .then(data => {
        if (isMounted) setAnimationData(data);
      })
      .catch(() => {
        if (isMounted) setAnimationData(null);
      });

    return () => {
      isMounted = false;
    };
  }, [message.body]);

  return (
    <Container>
      <StickerLabel>Figurinha</StickerLabel>
      {animationData && <Lottie animationData={animationData} loop />}
    </Container>
  );
}
